import React from 'react'
import {SGIcon} from "../component"

export const SGSearchIcon = props => <SGIcon src={require("../assets/images/search-icon.png")} {...props}/>